import { FC } from 'react'

import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'

import Table from './_Table'

interface Props {
  schema: EmployeeCustomTablesSchemaFragment
  attachableId: number
  currency: string
  canManage: boolean
  canAddValues: boolean
}

const CustomTableComponent: FC<Props> = ({
  schema,
  attachableId,
  currency,
  canManage,
  canAddValues,
}) => {
  return (
    <>
      <PanesHeader title={schema.label} />
      <Table
        attachableId={attachableId}
        schema={schema}
        canManage={canManage}
        canAddValues={canAddValues}
        currency={currency}
      />
    </>
  )
}

export default observer(CustomTableComponent)
